export default __webpack_public_path__ + "static/media/client-24.ab849bff.webp";